/*eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import { connect } from 'react-redux';

// Components
import SidePanel from '../../../../../../components/SidePanel';
import Icon from '../../../../../../components/Icon';
import Button from '../../../../../../components/Button';
import SidePanelListItem from '../../../../../../components/SidePanelListItem';
import NFList from './NFList';
import CancelScheduleModal from './CancelScheduleModal';

// Thunks + selectors
import { getScheduleNfList, cancelSchedule } from '../../../../../../redux/scheduling';
import { getScheduleNFListUI, getDeleteScheduleUI } from '../../../../../../redux/selectors';

// utils
import { scheduleTypesToLabel } from '../../../../util/scheduling';

// CSS
import './styles.css';

class ScheduleDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cancelModalIsOpen: false,
    };
  }

  componentDidMount() {
    this.props.dispatch(getScheduleNfList(this.props.data.id));
  }

  componentWillReceiveProps(nextProps) {
    // Detect when isFetching from cancelSchedule returns to false,
    // Close modal and dismiss side panel
    if (
      this.props.cancelScheduleUi.isFetching &&
      !nextProps.cancelScheduleUi.isFetching &&
      !nextProps.cancelScheduleUi.error
    ) {
      this.setState({
        cancelModalIsOpen: false,
      });

      this.props.onDismiss();
      this.props.openCancelConfirmationModal(this.props.data.id);
    }
  }


  _openCancelModal = () => {
    this.setState({
      cancelModalIsOpen: true,
    });
  }

  _onScheduleCancel = () => {
    this.props.dispatch(cancelSchedule(this.props.data.id));
  }

  _closeModal = () => {
    this.setState({
      cancelModalIsOpen: false,
    });
  }

  render() {
    const { onDismiss, data, cancelScheduleUi } = this.props;

    return (
      <SidePanel onDismiss={onDismiss}>
        <div className="ScheduleDetail">
          <div className="ScheduleDetail__header">
            <Icon
              className="ScheduleDetail__close-modal"
              name="close"
              onClick={onDismiss}
            />
            <h3 className="ScheduleDetail__header-title">Operação {data.id}</h3>

            <div className="ScheduleDetail__buttons">
              <Button
                className="ScheduleDetail__button-cancel"
                icon="close"
                text="Cancelar"
                skin="secondary"
                onClick={this._openCancelModal}
              />
            </div>
          </div>

          <div className="ScheduleDetail__info">
            <div className="ScheduleDetail__info-list">
              <SidePanelListItem title="Operação">
                {data.id}
              </SidePanelListItem>

              <SidePanelListItem title="CD">
                {data.warehouse}
              </SidePanelListItem>

              <SidePanelListItem title="Tipo Operação">
                {scheduleTypesToLabel[data.scheduleType]}
              </SidePanelListItem>

              <SidePanelListItem title="Cliente">
                {data.client}
              </SidePanelListItem>

              <SidePanelListItem title="Motorista">
                {data.driverName}
              </SidePanelListItem>

              <SidePanelListItem title="Veículo">
                {data.plate}
              </SidePanelListItem>
            </div>

            <div className="ScheduleDetail__info-nfs">
              <SidePanelListItem title="NFs do Agendamento">
                <NFList
                  activeNfData={this.props.data}
                  isFetching={this.props.ui.isFetching}
                  error={this.props.ui.error}
                  data={this.props.nfList}
                />
              </SidePanelListItem>
            </div>
          </div>

        </div>

        {
          this.state.cancelModalIsOpen &&
          <CancelScheduleModal
            isFetching={cancelScheduleUi.isFetching}
            hasError={cancelScheduleUi.error}
            onScheduleCancel={this._onScheduleCancel}
            closeModal={this._closeModal}
          />
        }
      </SidePanel>
    );
  }
}

function mapStateToProps(state) {
  return {
    nfList: state.scheduling.activeScheduleNFList.data,
    ui: getScheduleNFListUI(state),
    cancelScheduleUi: getDeleteScheduleUI(state),
  };
}

export default connect(mapStateToProps)(ScheduleDetail);
